import { render, staticRenderFns } from "./gallery-layout.vue?vue&type=template&id=e4bc997a&"
import script from "./gallery-layout.vue?vue&type=script&lang=js&"
export * from "./gallery-layout.vue?vue&type=script&lang=js&"
import style0 from "./gallery-layout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports